
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"45","height":"44","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":"7","y":"7","width":"12.222","height":"12.222","rx":"5","stroke":"#56BFC7","stroke-width":"2"}}),_c('rect',{attrs:{"x":"7","y":"24.777","width":"12.222","height":"12.222","rx":"5","stroke":"#56BFC7","stroke-width":"2"}}),_c('rect',{attrs:{"x":"24.778","y":"7","width":"12.222","height":"12.222","rx":"5","fill":"#56BFC7","stroke":"#56BFC7","stroke-width":"2"}}),_c('rect',{attrs:{"x":"24.778","y":"24.777","width":"12.222","height":"12.222","rx":"5","stroke":"#56BFC7","stroke-width":"2"}})])
          )
        }
      }
    